import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer"; // ✅ Import Footer
import Home from "./pages/Home";
import CategoryPage from "./pages/CategoryPage";
import BuyPremium from "./pages/BuyPremium";
import Courses from "./pages/Courses";
import Reviews from "./pages/Review";
import Resources from "./pages/Resource";

const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:category" element={<CategoryPage />} />
        <Route path="/buy-premium" element={<BuyPremium />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/resources" element={<Resources />} />
      </Routes>
      <Footer /> {/* ✅ Add Footer at the bottom */}
    </Router>
  );
};

export default App;
